import React from 'react';
import './Styles/globals.css';
import {  Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useDispatch, useSelector } from 'react-redux';
import { clearAuthData } from '../store/slices/authSlice';
import type { RootState } from '../store/store';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationContainer } from 'react-notifications';
import { useIdleTimer } from 'react-idle-timer'

function Header(): JSX.Element {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);

  const onIdle = (): void => {
    handleLogout()
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { getRemainingTime } = useIdleTimer({
    onIdle,
    // onActive,
    // onAction,
    timeout: 3600000,
    throttle: 500
  })

  const handleLogout = (): void => {
    localStorage.clear();
    logout();
    dispatch(clearAuthData());
    navigate('/');
  };

  return (
    <div>
      <NotificationContainer />
      <div className="flex gap-x-1 navbar bg-white px-10 h-[60px]">
        <div className="basis-3/5">
          <div className="form-control" style={{ width: '100%' }}>
            <input
              type="text"
              placeholder="Search"
              className="input text-muted text-14 input-bordered w-auto header-search focus:ring-0 focus:outline-none focus:border-primary"
            />
          </div>
        </div>
        <div className="basis-2/5 justify-end">
          <button className="btn btn-ghost btn-circle notification-icon">
            <div className="indicator">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
              >
                <path
                  d="M10.1541 21.9998C9.25649 21.9998 8.3956 21.6432 7.76086 21.0085C7.12612 20.3737 6.76953 19.5129 6.76953 18.6152C6.76953 18.3908 6.85868 18.1756 7.01736 18.0169C7.17605 17.8582 7.39127 17.769 7.61569 17.769H12.6926C12.917 17.769 13.1322 17.8582 13.2909 18.0169C13.4496 18.1756 13.5388 18.3908 13.5388 18.6152C13.5388 19.5129 13.1822 20.3737 12.5474 21.0085C11.9127 21.6432 11.0518 21.9998 10.1541 21.9998ZM8.6903 19.4614C8.83906 19.7178 9.05259 19.9307 9.30949 20.0786C9.5664 20.2266 9.85767 20.3045 10.1541 20.3045C10.4506 20.3045 10.7419 20.2266 10.9988 20.0786C11.2557 19.9307 11.4692 19.7178 11.618 19.4614H8.6903Z"
                  fill="#CAC9C9"
                />
                <path
                  d="M11.846 3.38462H8.46139C8.23697 3.38462 8.02175 3.29547 7.86307 3.13678C7.70438 2.9781 7.61523 2.76288 7.61523 2.53846C7.61523 1.86522 7.88268 1.21955 8.35873 0.743498C8.83479 0.267444 9.48045 0 10.1537 0C10.8269 0 11.4726 0.267444 11.9487 0.743498C12.4247 1.21955 12.6922 1.86522 12.6922 2.53846C12.6922 2.76288 12.603 2.9781 12.4443 3.13678C12.2856 3.29547 12.0704 3.38462 11.846 3.38462Z"
                  fill="#CAC9C9"
                />
                <path
                  d="M19.4615 19.4616H0.846156C0.621742 19.4616 0.406519 19.3725 0.247835 19.2138C0.0891501 19.0551 1.78629e-06 18.8399 1.78629e-06 18.6155C-0.00074029 17.6599 0.229738 16.7183 0.671767 15.871C1.11379 15.0238 1.75425 14.2961 2.53846 13.7501V9.30777C2.53842 7.29681 3.33378 5.36746 4.75098 3.94075C6.16818 2.51404 8.09216 1.70579 10.1031 1.69238H10.1962C12.2159 1.69238 14.1529 2.49472 15.581 3.92288C17.0092 5.35104 17.8115 7.28804 17.8115 9.30777V13.7501C18.5879 14.3008 19.2202 15.0305 19.6547 15.8775C20.0892 16.7244 20.3132 17.6636 20.3077 18.6155C20.3077 18.8399 20.2185 19.0551 20.0599 19.2138C19.9012 19.3725 19.686 19.4616 19.4615 19.4616ZM1.77692 17.7693H18.5308C18.4109 17.1827 18.1679 16.6282 17.8179 16.1425C17.4678 15.6567 17.0186 15.2508 16.5 14.9516C16.3709 14.8771 16.2637 14.7697 16.1894 14.6404C16.1152 14.5112 16.0763 14.3646 16.0769 14.2155V9.30777C16.0769 7.73687 15.4529 6.23031 14.3421 5.11952C13.2313 4.00873 11.7247 3.38469 10.1538 3.38469C8.58295 3.38469 7.07639 4.00873 5.9656 5.11952C4.85481 6.23031 4.23077 7.73687 4.23077 9.30777V14.2155C4.23136 14.3646 4.19255 14.5112 4.11825 14.6404C4.04396 14.7697 3.93682 14.8771 3.80769 14.9516C3.28909 15.2508 2.83991 15.6567 2.48983 16.1425C2.13976 16.6282 1.89677 17.1827 1.77692 17.7693Z"
                  fill="#CAC9C9"
                />
                <circle cx="16.077" cy="5.92319" r="3.38462" fill="#F13139" />
              </svg>
            </div>
          </button>
          <ul className="menu menu-horizontal px-1 profile-badge">
            <li>
              <details>
                <summary>
                  <p className="profile-heading">
                    <span className="main-heading">
                      {user?.firstName} {user?.lastName}
                    </span>
                    <br />
                    <p className="prfile-sub-heading">Healthlink Dimensions</p>
                  </p>
                </summary>
                <ul className="p-2 bg-base-100 sub-menu mt-[4px] absolute right-0 z-[1001]">
                  {user && 
                  <li className="text-14 text-muted">
                    <Link
                     to={`/settings/manage-users/edit/${user.id}`} 
                      className="hover:text-primary hover:bg-hoverbg"
                    >
                      Profile
                    </Link>
                  </li>
                  }
                  <li className="text-14 text-muted">
                    <button
                      onClick={handleLogout}
                      className="hover:text-primary hover:bg-hoverbg w-full text-left"
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </details>
            </li>
          </ul>
          <label tabIndex={0} className="btn btn-ghost btn-circle profile-icon">
            <div className="w-10 rounded-full">{`A`}</div>
          </label>
        </div>
      </div>
    </div>
  );
}

export default Header;
